<template>
    <div id="ecmMapControls" :class="{ 'search-enabled': config && config.showGeosearch }">

        <button
            v-if="config && config.showFullscreenToggle" 
            @click="toggleFullscreen">
            <SvgIcon 
                v-show="!fullscreen"
                icon="icon-fullscreen-open"
                title="Toggle fullscreen">
            </SvgIcon>
            <SvgIcon 
                v-show="fullscreen"
                icon="icon-fullscreen-close"
                title="Toggle fullscreen">
            </SvgIcon>
            <span class="sr-only">Toggle fullscreen</span>
        </button>

        <div class="ecm-btn-grp-v">
            <button
                @click="zoomIn"
                class="ecm-zoom-in">
                <SvgIcon 
                    icon="icon-plus"
                    title="Zoom in">
                </SvgIcon>
                <span class="sr-only">Zoom in</span>
            </button>

            <button
                @click="zoomOut"
                class="ecm-zoom-out">
                <SvgIcon 
                    icon="icon-minus"
                    title="Zoom out">
                </SvgIcon>
                <span class="sr-only">Zoom out</span>
            </button>
        </div>

        <button
            v-if="config && config.showMyLocationButton" 
            @click="getLocation"
            :class="{ loading: gettingUserLocation}">
            <SvgIcon 
                icon="icon-location"
                :title="$t('myLocationShow')">
            </SvgIcon>
            <span class="sr-only">{{ $t('myLocationShow') }}</span>
        </button>

    </div>
</template>

<script>
import { eventBus } from '../main.js';
import { store } from '../store/store';
import SvgIcon from './SvgIcon.vue';

export default {
    name: 'MapControls',
    components: {
        SvgIcon
    },
    data: function () {
        return {

        }
    },
    store: store,
    computed: {
        fullscreen() {
            return store.state.fullscreen;
        },
        config() {
            return store.state.config;
        },
        gettingUserLocation() {
            return store.state.gettingUserLocation;
        }
    },
    methods: {
        toggleFullscreen() {
            eventBus.$emit('toggleFullscreen');
        },
        zoomIn() {
            eventBus.$emit('zoomIn');
        },
        zoomOut() {
            eventBus.$emit('zoomOut');
        },
        getLocation() {
            eventBus.$emit('getLocation');
        }
    }
}

</script>

<style>

</style>
